import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react'
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import CosegurosService from '../../../services/CosegurosService';
import LaboratorioService from '../../../services/LaboratorioService';
import DiscapacidadService from '../../../services/DiscapacidadService';

const BuscadorPractica = forwardRef(({ label, fieldsDisabled, cod, setCod, autorizacion, gestionAutorizacion, 
    integracion, internacionDomiciliaria = false, liquidaciones = false, idEfectorFacturacion, 
    idTipoNomenclador, esLineaCodigoLiq = false, esPresupuesto = false, laboratorio = false,
    idSolicitud }, ref) => {

    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState(false);
    const [options, setOptions] = useState([]);

    useImperativeHandle(ref, () => ({
        resetValues: () => {
            setOptions([]);
        }
    }));

    useEffect(() => {
        let active = true;

        setLoading(true);

        if (inputValue === '') {
            setOptions(cod ? [cod] : []);
            setLoading(false);
            return undefined;
        }

        if (search) {
            (async () => {
                let response;
                if (liquidaciones) {
                    response = await CosegurosService.getPracticaLiquidaciones(inputValue, esLineaCodigoLiq, idEfectorFacturacion, idTipoNomenclador);
                } else {
                    autorizacion || gestionAutorizacion
                    ?
                        laboratorio
                        ?   idSolicitud
                                ? response = await LaboratorioService.getBuscardorPracticasLaboratorioEfectorTexto(inputValue, idSolicitud)
                                : response = await LaboratorioService.getBuscardorPracticasLaboratorioTexto(inputValue)
                        :   integracion
                                ? response = await DiscapacidadService.traerNomencladorIntegracion(inputValue)
                                : response = await CosegurosService.getBuscardorPracticasAutorizacionTexto(inputValue, internacionDomiciliaria, integracion, esPresupuesto)
                    :                             
                        response = await CosegurosService.getBuscardorPracticasCoseguroTexto(inputValue);
                }

                const results = await response.json();
                if (active) {
                    let newOptions = [];

                    if (cod) {
                        newOptions = [cod];
                    }
                    
                    newOptions = [...newOptions, ...results];

                    setOptions(newOptions);
                    setLoading(false);
                }
            })();
        }
        return () => {
            active = false;
        };

    }, [cod, inputValue, search]);

    // if(cod){
    //     console.log({liquidaciones, autorizacion, gestionAutorizacion, integracion, laboratorio, idSolicitud});
        // console.log({cod});
    // }

    return (
        <Autocomplete
            id="asynchronous-demo"
            disabled={fieldsDisabled}
            getOptionLabel={(option) => {
                return integracion
                    ? `${option.codIntegrador} / ${option.codNom} - ${option.modulo}`
                    : `${option.codNom}-${option.desNom}`
            }}
            filterOptions={(x) => x}
            style={{
                padding: gestionAutorizacion && 6,
                backgroundColor: gestionAutorizacion && "#FAFAFA",
                borderRadius: gestionAutorizacion && "5px",
            }}
            options={options}
            autoComplete
            includeInputInList
            filterSelectedOptions
            value={cod}
            onChange={(_event, newValue) => {
                setOptions(newValue ? [newValue, ...options] : options);
                if (newValue) {
                    setCod(autorizacion
                        ? integracion
                            ? { ...newValue, idCodNom: newValue.idNi }
                            : laboratorio && !idSolicitud
                                ? newValue
                                : { ...newValue, idCodNom: newValue.id }
                        : newValue
                    );
                } else {
                    setCod(newValue);
                }
                setSearch(false);
            }}
            onInputChange={(_event, newInputValue) => {
                setInputValue(newInputValue);
                setSearch(true);
            }}
            noOptionsText="No hay practicas"
            loadingText="Buscando..."
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    fullWidth
                    style={{
                        padding: gestionAutorizacion && 3,
                    }}
                    variant={gestionAutorizacion && "outlined"}
                />
            )}
        />
    )
})

export default BuscadorPractica